import { render, staticRenderFns } from "./PageImageGuidelines.vue?vue&type=template&id=39c4f079&"
import script from "./PageImageGuidelines.vue?vue&type=script&lang=js&"
export * from "./PageImageGuidelines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports